export const SET_QUOTES = 'SET_QUOTES';



// WEBPACK FOOTER //
// ./src/actions/loginActionTypes.js